import { useEffect, useState } from 'react'
import { supabase } from '../supabaseClient'

export function usePublicCases(limit = 10) {
  const [cases, setCases] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetch = async () => {
      const { data, error } = await supabase
        .from('cases')
        .select('*')
        .eq('status', 'published')
        .order('created_at', { ascending: false })
        .limit(limit)
      if (!error) setCases(data || [])
      setLoading(false)
    }
    fetch()
  }, [limit])

  return { cases, loading }
}

export function usePublicCase(slug) {
  const [c, setC] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!slug) return
    const fetch = async () => {
      const { data, error } = await supabase
        .from('cases')
        .select('*')
        .eq('slug', slug)
        .eq('status', 'published')
        .single()
      if (!error) setC(data)
      setLoading(false)
    }
    fetch()
  }, [slug])

  return { case: c, loading }
}
